import { IconComponent } from 'models/icons';

/**
 * @deprecated This component has following errors from generation:
 *
 * **ERROR: assets/icons/torus.svg has a stroke color. Please outline strokes in figma before exporting it to svg.**
 *
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/torus.svg
 */
const IconTorus: IconComponent = ({
  size = 24,
  color = '#ffffff',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M12 23.5c6.351 0 11.5-5.149 11.5-11.5S18.351.5 12 .5.5 5.649.5 12 5.649 23.5 12 23.5z"
      stroke="currentColor"
      strokeWidth={0.36}
      strokeMiterlimit={10}
    />
    <path
      d="M12 17.023a5.023 5.023 0 100-10.046 5.023 5.023 0 000 10.046z"
      stroke="currentColor"
      strokeWidth={0.36}
      strokeMiterlimit={10}
    />
  </svg>
);

export default IconTorus;
